import {
  AddressField as OriginalAddressField,
  AddressFieldConfig as OriginalAddressFieldConfig,
} from './AddressField';
import {
  AddressField as LazyAddressField,
  AddressFieldConfig as LazyAddressFieldConfig,
} from './LazyAddressField';
export type {
  AddressFieldCountryCode,
  AddressValue,
  AddressValueAdapter,
  AddressAutocompleteItem,
  SubregionOverride,
} from './AddressField';

declare global {
  const SAIL_EXPERIMENTAL_ADDRESS_FIELD: boolean | void;
}

const isExperimental =
  typeof SAIL_EXPERIMENTAL_ADDRESS_FIELD !== 'undefined' &&
  !!SAIL_EXPERIMENTAL_ADDRESS_FIELD;

const AddressField: typeof OriginalAddressField = isExperimental
  ? LazyAddressField
  : OriginalAddressField;

const AddressFieldConfig: typeof OriginalAddressFieldConfig = isExperimental
  ? LazyAddressFieldConfig
  : OriginalAddressFieldConfig;

export {AddressField, AddressFieldConfig};
